module.exports = __webpack_public_path__ + "img/designer-portfolio.c9455cbd.webp";